/* eslint semi:0 */
import m from 'mithril'
import BaseView from './BaseView'
import userStore from '../stores/userStore'
import { fbLogin } from '../actions/userToolbarActions'
import { embedConfigurationChanged } from '../actions/embedCodeModalActions'
import { t, localizedPath, translateTrusted } from '../../providers/i18nProvider/i18nProvider'
import { getSiteDomainWithTld } from '../../application/pageDataObject'

export default class EmbedCodeModalView extends BaseView {
  view(ctrl) {
    let { dataReady, dataError, configuration } = ctrl.vm.state
    let currentView = m('span.embed-modal--loading')
    if (dataReady) {
      currentView = [
        m('header.modal__header', m('h1.modal__title', t('embed.dialogue.header'))),
        m('section.modal__body', [
          m('h4', t('embed.dialogue.customise_collapse/expand')),
          this.customizationOptionsView(configuration),
          this.copyPasteView(ctrl.vm),
          // this.becomePartnerView(),
        ]),
      ]
    } else if (dataError) {
      currentView = 'Something went wrong :-('
    }
    return m('.embed-modal', currentView)
  }

  customizationOptionsView(configuration) {
    let optionsView = []
    for (let option in configuration) {
      if (option.match(/^(show|hide)-/)) {
        let isChecked = configuration[option]
        optionsView.push(
          m('label.checkbox.checkbox-${ option }', [
            m('input.embed-modal__config-options__input[type=checkbox]', {
              checked: isChecked,
              onchange: embedConfigurationChanged.part(option),
            }),
            m('span', t(`embed.dialogue.${option}`)),
          ])
        )
      }
    }
    return m('div.embed-modal__config-options', optionsView)
  }

  copyPasteView(vm) {
    let embedCode = vm.store.embedCodePretty
    let termsLink = `<a class='embed-modal__copy-paste-link' href="${localizedPath(
      '/terms'
    )}" target='_blank'>${t('footer.terms_conditions')}</a>`
    let disclaimerMarkup = translateTrusted('embed.dialogue.disclaimer', {
      terms_conditions: termsLink,
    }) // eslint-disable-line camelcase
    return m('div.embed-modal__copy-paste-area', [
      m('h4.embed-modal__copy-paste-title', t('embed.dialogue.embed_code')),
      m('span', t('embed.dialogue.embed_instructions')),
      m(
        'code.textarea.embed-modal__embed-code',
        {
          onclick: e => {
            vm.selectEmbedCode(e.currentTarget)
          },
          config: vm.selectEmbedCode,
        },
        embedCode
      ),
      m('.embed-modal__embed-disclaimer', disclaimerMarkup),
    ])
  }

  becomePartnerView() {
    let view = []
    let loginLink = `<a href=''>${t('affiliates.log_in')}</a>`
    const siteDomainWithTld = getSiteDomainWithTld()
    let { isLoggedIn, partnerId } = userStore
    if (!(isLoggedIn && partnerId)) {
      let emailLink = `<a href='mailto:partners@${siteDomainWithTld}' target='_blank'>partners@${siteDomainWithTld}</a>`
      view = view.concat([
        m('h5.embed-modal__partner__title', t('embed.dialogue.become_a_partner')),
        m('p', translateTrusted('embed.dialogue.logged_in', { email: emailLink })),
      ])
    }
    if (!isLoggedIn) {
      view.push(
        m(
          'span',
          {
            onclick: e => {
              e.preventDefault()
              fbLogin()
            },
          },
          translateTrusted('embed.dialogue.partner_message', { login: loginLink })
        )
      )
    }

    return m('footer.modal__footer.embed-modal__partner', view)
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/EmbedCodeModalView.js